import uniqueId from "@insite/mobius/utilities/uniqueId";
import textToSafeId from "@toolkit/Framework/Common/Utilities/textToSafeId";
import { useAnchorContext } from "@toolkit/Framework/Components/AnchorContext";
import { useEffect, useMemo } from "react";

export default (name: string, label?: string) => {
    const { addOrUpdateLink, removeLink } = useAnchorContext();
    const uid = useMemo(() => uniqueId(), []);
    const id = useMemo(() => textToSafeId(name), [name]);

    useEffect(() => {
        if (id) {
            addOrUpdateLink({ id, label: label || name, uid });
        } else {
            removeLink(uid);
        }
    }, [id, label]);

    useEffect(() => {
        return () => removeLink(uid);
    }, []);

    return id;
};
